import PropTypes from 'prop-types';
import { PrimaryButton, SecondaryButton } from 'jl-design-system/elements/button/Button';

import styles from './FormEditButtons.scss';

export const FormWarningButtons = ({ cancelHandler, saveEditingHandler, extraClassName = '' }) => (
  <div className={[styles.FormEditButtons, extraClassName].join(' ')} data-testid="FormEditButtons">
    <SecondaryButton inline className={styles.WarningCancelButton} onClick={cancelHandler}>
      Back to edit
    </SecondaryButton>
    <PrimaryButton inline className={styles.WarningSaveButton} onClick={saveEditingHandler}>
      Continue
    </PrimaryButton>
  </div>
);

FormWarningButtons.propTypes = {
  cancelHandler: PropTypes.func.isRequired,
  saveEditingHandler: PropTypes.func.isRequired,
  extraClassName: PropTypes.string,
};
